import { isFunction } from 'lodash';
import { type Type } from '@angular/core';

export function isType<T = unknown>(item: unknown): item is Type<T> {
  return isFunction(item);
}
